// extracted by mini-css-extract-plugin
export var measureBox = "_ao-0";